export const firebaseConfig = {
    apiKey: "AIzaSyAWNh46IUdHJXS_rXDpvWS926cB_OyDRu0",
    authDomain: "nabed-agency.firebaseapp.com",
    databaseURL: "https://nabed-agency.firebaseio.com",
    projectId: "nabed-agency",
    storageBucket: "nabed-agency.appspot.com",
    messagingSenderId: "1072229610919",
    appId: "1:1072229610919:web:928572682cba449542b282"
};